<template>
  <div class="tour_quick_actions flex flex-wrap gap-x-3 gap-y-5">
    <action-button
      v-if="canSwap"
      bg-color="bg-orange-300"
      bg-color-square="bg-orange-100"
      border-color="border-transparent"
      icon="swap"
      icon-color="text-orange-600"
      :libelle="
        'Intervertir les ' +
          ((structure &&structure.type === constants.TYPE_OF
          ) ||
            $freeParticulier() ||
            $isGuest() ? 'référentiels'
            : 'postes')

      "
      text-color="text-gray-900"
      @clickAction="displaySwap"
      :responsive="true"
    />
    <div class="md:relative">
      <action-button
        v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
        bg-color="bg-indigo-300"
        bg-color-square="bg-indigo-200"
        border-color="border-transparent"
        icon="printer"
        icon-color="text-indigo-600"
        libelle="Imprimer"
        text-color="text-gray-900"
        @clickAction="displayDropDownPrint"
        :responsive="true"
      />
      <!-- BEGIN Menu dropdown export -->
      <transition
        enter-active-class="ease-out duration-150"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div
          class="dropDownPrintMenu z-20 absolute md:left-0 top-1/6 md:top-12 mt-1 p-10 w-max ml-auto rounded-md bg-white shadow-md shadow-gray-600 text-sm font-normal"
          v-if="dropDownPrintMenu"
          v-clickOutside="forceHide"
        >
          <div class="flex justify-center mb-5 text-lg text-gray-600">
            <div
              @click="typeExport = 'neopass'"
              class="cursor-pointer"
              :class="{
                'text-indigo-600': typeExport == 'neopass',
              }"
            >
              Carnet de parcours
            </div>
            <div
              @click="typeExport = 'cv'"
              class="cursor-pointer mx-10"
              :class="{ 'text-indigo-600': typeExport == 'cv' }"
            >
              CV
            </div>
            <div
              v-if="
                $can(
                  constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EXPORTER
                )
              "
              @click="typeExport = 'fiche'"
              class="cursor-pointer"
              :class="{
                'text-indigo-600': typeExport == 'fiche',
              }"
            >
              Fiches de poste
            </div>
            <div
              v-if="
                $can(
                  constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EXPORTER
                )
              "
              @click="typeExport = 'refFormation'"
              class="cursor-pointer"
              :class="{
                'text-indigo-600': typeExport == 'refFormation',
              }"
            >
              Référentiel de formation
            </div>
          </div>

          <div v-if="typeExport == 'neopass'">
            <h6 class="mb-5">
              Quels modules voulez vous imprimer ?
            </h6>
            <div>
              <checkbox-indigo
                name="allModule"
                libelle="Tout"
                :value="
                  listModulesToExport.length == listModulesPagesToExport.length
                "
                @input="
                  (newValue) => {
                    selectAllModuleToExport();
                  }
                "
                :force-active-in-neopass-form="true"
              />
              <checkbox-indigo
                v-for="(
                  mod, indexMod
                ) in listModulesPagesToExport"
                :key="indexMod"
                :name="mod.name"
                :libelle="mod.display_name"
                :value="listModulesToExport.includes(mod.id)"
                @input="
                  (newValue) => {
                    addModuleToExport(mod.id);
                  }
                "
                class="ml-5"
                :force-active-in-neopass-form="true"
              />
            </div>
            <div
              class="mt-10 flex justify-center"
              v-if="typeExportInProgress == ''"
            >
              <action-button
                v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                libelle="Imprimer"
                @clickAction="exporterNeopass(false)"
              />
            </div>
            <div
              class="mt-10 flex justify-center"
              v-else-if="typeExportInProgress == 'neopass'"
            >
              <action-button
                v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                libelle="Ouverture en cours"
                :spinner="true"
              />
            </div>
            <div
              class="mt-10 flex justify-center"
              v-else
            >
              <action-button
                v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-gray-600"
                libelle="Imprimer"
              />
            </div>
            <div
              class="mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
              v-if="errorExportPdf != ''"
            >
              {{ errorExportPdf }}
            </div>
          </div>

          <div v-if="typeExport == 'cv'">
            <div
              class="mt-5"
              v-if="typeExportInProgress == ''"
            >
              <action-button
                v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                :libelle="'Imprimer un CV'"
                @clickAction="exporterCV(false)"
              />
            </div>
            <div
              class="mt-5"
              v-else-if="typeExportInProgress == 'cv'"
            >
              <action-button
                v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                libelle="Ouverture en cours"
                :spinner="true"
              />
            </div>
            <div
              class="mt-5"
              v-else
            >
              <action-button
                v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-gray-600"
                :libelle="'Imprimer un CV'"
              />
            </div>
            <div
              class="mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
              v-if="errorExportPdf != ''"
            >
              {{ errorExportPdf }}
            </div>
          </div>

          <div v-if="typeExport == 'fiche'">
            <div
              v-if="
                jobs.filter((j) => Object.keys(j).length > 0)
                  .length > 0
              "
            >
              <h6 class="mb-5">
                Quelle fiche de poste voulez vous imprimer ?
              </h6>

              <div
                v-for="(job, kjob) in uniqueJobs"
                :key="kjob"
              >
                <div
                  class="mt-5"
                  v-if="typeExportInProgress == ''"
                >
                  <action-button
                    v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                    border-color="border-transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    :libelle="
                      'Imprimer la fiche du poste ' + job.page_template.name
                    "
                    @clickAction="exporterFiche(false, job)"
                  />
                </div>
                <div
                  class="mt-5"
                  v-else-if="
                    typeExportInProgress ==
                      'fiche' + job.page_template.name
                  "
                >
                  <action-button
                    v-if="
                      $can(
                        constants.PERMISSION_NEOPASS_EXPORT
                      )
                    "
                    border-color="border-transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Ouverture en cours"
                    :spinner="true"
                  />
                </div>
                <div
                  class="mt-5"
                  v-else
                >
                  <action-button
                    v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                    border-color="border-transparent"
                    text-color="text-white"
                    bg-color="bg-gray-600"
                    :libelle="
                      'Imprimer la fiche du poste ' + job.page_template.name
                    "
                  />
                </div>
              </div>
              <div
                class="mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
                v-if="errorExportPdf != ''"
              >
                {{ errorExportPdf }}
              </div>
            </div>
            <div
              v-else
              class="text-gray-600"
            >
              Vous n'avez pas de poste défini dans les compétences
              professionnelles
            </div>
          </div>

          <div v-if="typeExport == 'refFormation'">
            <div
              v-if="
                jobs.filter((j) => Object.keys(j).length > 0)
                  .length > 0
              "
            >
              <h6 class="mb-5">
                Quelle référentiel de formation voulez vous
                imprimer ?
              </h6>

              <div
                v-for="(job, kjob) in uniqueJobs"
                :key="kjob"
              >
                <div
                  class="mt-5"
                  v-if="typeExportInProgress == ''"
                >
                  <action-button
                    v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                    border-color="border-transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    :libelle="
                      'Exporter le référentiel de formation ' +
                        job.page_template.name
                    "
                    @clickAction="exporterRefFormation(false, job)"
                  />
                </div>
                <div
                  class="mt-5"
                  v-else-if="
                    typeExportInProgress ==
                      'refFormation' + job.page_template.name
                  "
                >
                  <action-button
                    v-if="
                      $can(
                        constants.PERMISSION_NEOPASS_EXPORT
                      )
                    "
                    border-color="border-transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Export en cours"
                    :spinner="true"
                  />
                </div>
                <div
                  class="mt-5"
                  v-else
                >
                  <action-button
                    v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                    border-color="border-transparent"
                    text-color="text-white"
                    bg-color="bg-gray-600"
                    :libelle="
                      'Exporter le référentiel de formation ' +
                        job.page_template.name
                    "
                  />
                </div>
              </div>
              <div
                class="mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
                v-if="errorExportPdf != ''"
              >
                {{ errorExportPdf }}
              </div>
            </div>
            <div
              v-else
              class="text-gray-600"
            >
              Vous n'avez pas de formation défini dans les
              compétences
              professionnelles
            </div>
          </div>
        </div>
      </transition>
      <!-- END Menu dropdown export -->
    </div>

    <div class="md:relative">
      <action-button
        v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
        bg-color="bg-teal-300"
        bg-color-square="bg-teal-100"
        border-color="border-transparent"
        icon="upload"
        icon-color="text-teal-600"
        libelle="Exporter en PDF"
        text-color="text-gray-900"
        @clickAction="displayDropDownExport()"
        :responsive="true"
      />
      <!-- BEGIN Menu dropdown export -->
      <transition
        enter-active-class="ease-out duration-150"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div
          class="dropDownExportMenu z-20 absolute -left-0 mx-6 md:mx-0 md:left-0 top-1/6 md:top-12 mt-1 p-10 w-max rounded-md bg-white shadow-md shadow-gray-600 text-sm font-normal"
          v-if="dropDownExportMenu"
          v-clickOutside="forceHide"
        >
          <div class="flex justify-center mb-5 text-lg text-gray-600">
            <div
              @click="typeExport = 'neopass'"
              class="cursor-pointer"
              :class="{
                'text-indigo-600': typeExport == 'neopass',
              }"
            >
              Carnet de parcours
            </div>
<!--            <div
              @click="typeExport = 'cv'"
              class="cursor-pointer mx-10"
              :class="{ 'text-indigo-600': typeExport == 'cv' }"
            >
              CV
            </div>
            <div
              v-if="
                $can(
                  constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EXPORTER
                )
              "
              @click="typeExport = 'fiche'"
              class="cursor-pointer"
              :class="{
                'text-indigo-600': typeExport == 'fiche',
              }"
            >
              Fiches de poste
            </div>-->
            <div
              v-if="
                $can(
                  constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EXPORTER
                )
              "
              @click="typeExport = 'refFormation'"
              class="cursor-pointer"
              :class="{
                'text-indigo-600': typeExport == 'refFormation',
              }"
            >
              Référentiel de formation
            </div>
          </div>

          <div v-if="typeExport == 'neopass'">
            <h6 class="mb-5">
              Quels modules voulez vous exporter ?
            </h6>
            <div>
              <checkbox-indigo
                name="allModule"
                libelle="Tout"
                :value="
                  listModulesToExport.length == listModulesPagesToExport.length
                "
                @input="
                  (newValue) => {
                    selectAllModuleToExport();
                  }
                "
                :force-active-in-neopass-form="true"
              />
              <checkbox-indigo
                v-for="(
                  mod, indexMod
                ) in listModulesPagesToExport"
                :key="indexMod"
                :name="mod.name"
                :libelle="mod.display_name"
                :value="listModulesToExport.includes(mod.id)"
                @input="
                  (newValue) => {
                    addModuleToExport(mod.id);
                  }
                "
                class="ml-5"
                :force-active-in-neopass-form="true"
              />
            </div>
            <div
              class="mt-10 flex justify-center"
              v-if="typeExportInProgress == ''"
            >
              <action-button
                v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                libelle="Exporter en PDF"
                @clickAction="exporterNeopass(true)"
              />
            </div>
            <div
              class="mt-10 flex justify-center"
              v-else-if="typeExportInProgress == 'neopass'"
            >
              <action-button
                v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                libelle="Export en cours"
                :spinner="true"
              />
            </div>
            <div
              class="mt-10 flex justify-center"
              v-else
            >
              <action-button
                v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-gray-600"
                libelle="Exporter en PDF"
              />
            </div>
            <div
              class="mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
              v-if="errorExportPdf != ''"
            >
              {{ errorExportPdf }}
            </div>
          </div>

          <div v-if="typeExport == 'cv'">
            <div
              class="mt-5"
              v-if="typeExportInProgress == ''"
            >
              <action-button
                v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                :libelle="'Exporter un CV'"
                @clickAction="exporterCV(true)"
              />
            </div>
            <div
              class="mt-5"
              v-else-if="typeExportInProgress == 'cv'"
            >
              <action-button
                v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                libelle="Export en cours"
                :spinner="true"
              />
            </div>
            <div
              class="mt-5"
              v-else
            >
              <action-button
                v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-gray-600"
                :libelle="'Exporter un CV'"
              />
            </div>
            <div
              class="mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
              v-if="errorExportPdf != ''"
            >
              {{ errorExportPdf }}
            </div>
          </div>

          <div v-if="typeExport == 'fiche'">
            <div
              v-if="
                jobs.filter((j) => Object.keys(j).length > 0)
                  .length > 0
              "
            >
              <h6 class="mb-5">
                Quelle fiche de poste voulez vous exporter ?
              </h6>

              <div
                v-for="(job, kjob) in uniqueJobs"
                :key="kjob"
              >
                <div
                  class="mt-5"
                  v-if="typeExportInProgress == ''"
                >
                  <action-button
                    v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                    border-color="border-transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    :libelle="
                      'Exporter la fiche du poste ' + job.page_template.name
                    "
                    @clickAction="exporterFiche(true, job)"
                  />
                </div>
                <div
                  class="mt-5"
                  v-else-if="
                    typeExportInProgress ==
                      'fiche' + job.page_template.name
                  "
                >
                  <action-button
                    v-if="
                      $can(
                        constants.PERMISSION_NEOPASS_EXPORT
                      )
                    "
                    border-color="border-transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Export en cours"
                    :spinner="true"
                  />
                </div>
                <div
                  class="mt-5"
                  v-else
                >
                  <action-button
                    v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                    border-color="border-transparent"
                    text-color="text-white"
                    bg-color="bg-gray-600"
                    :libelle="
                      'Exporter la fiche du poste ' + job.page_template.name
                    "
                  />
                </div>
              </div>
              <div
                class="mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
                v-if="errorExportPdf != ''"
              >
                {{ errorExportPdf }}
              </div>
            </div>
            <div
              v-else
              class="text-gray-600"
            >
              Vous n'avez pas de poste défini dans les compétences
              professionnelles
            </div>
          </div>

          <div v-if="typeExport == 'refFormation'">
            <div
              v-if="
                jobs.filter((j) => Object.keys(j).length > 0)
                  .length > 0
              "
            >
              <h6 class="mb-5">
                Quelle référentiel de formation voulez vous
                exporter ?
              </h6>

              <div
                v-for="(job, kjob) in uniqueJobs"
                :key="kjob"
              >
                <div
                  class="mt-5"
                  v-if="typeExportInProgress == ''"
                >
                  <action-button
                    v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                    border-color="border-transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    :libelle="
                      'Exporter le référentiel de formation ' +
                        job.page_template.name
                    "
                    @clickAction="exporterRefFormation(true, job)"
                  />
                </div>
                <div
                  class="mt-5"
                  v-else-if="
                    typeExportInProgress ==
                      'refFormation' + job.page_template.name
                  "
                >
                  <action-button
                    v-if="
                      $can(
                        constants.PERMISSION_NEOPASS_EXPORT
                      )
                    "
                    border-color="border-transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Export en cours"
                    :spinner="true"
                  />
                </div>
                <div
                  class="mt-5"
                  v-else
                >
                  <action-button
                    v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                    border-color="border-transparent"
                    text-color="text-white"
                    bg-color="bg-gray-600"
                    :libelle="
                      'Exporter le référentiel de formation ' +
                        job.page_template.name
                    "
                  />
                </div>
              </div>
              <div
                class="mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
                v-if="errorExportPdf != ''"
              >
                {{ errorExportPdf }}
              </div>
            </div>
            <div
              v-else
              class="text-gray-600"
            >
              Vous n'avez pas de formation défini dans les
              compétences
              professionnelles
            </div>
          </div>
        </div>
      </transition>
      <!-- END Menu dropdown export -->
    </div>
    <router-link
      v-if="$can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_DISPLAY)"
      :to="{ name: 'Cartoindcompperso' }"
    >
      <action-button
        bg-color="bg-pink-300"
        bg-color-square="bg-pink-100"
        border-color="border-transparent"
        icon="bar-chart-2"
        icon-color="text-pink-600"
        libelle="Cartographie individuelle"
        text-color="text-gray-900"
        disabled-tooltip="pour profiter de cette fonctionnalité veuillez faire une deuxième évaluation pour les comparer"
        :responsive="true"
        :enable-action="false"
      />
    </router-link>

    <action-button
      id="form-action-frise"
      v-if="moduleName == 'cv'"
      bg-color="bg-orange-300"
      bg-color-square="bg-orange-100"
      border-color="border-transparent"
      icon="person"
      icon-color="text-orange-600"
      libelle="Frise chronologique"
      text-color="text-gray-900"
      @clickAction="displayFriseChronologique"
      :responsive="true"
    />

    <action-button
      v-if="$can('neopass_form_historic')"
      bg-color="bg-gray-300"
      bg-color-square="bg-gray-100"
      border-color="border-transparent"
      icon="file-text"
      icon-color="text-gray-600"
      libelle="Historique"
      text-color="text-gray-900"
      :responsive="true"
    />

    <router-link :to="{name: 'UserHistory', params: {user: infosPass.id_pass}}">
      <action-button
        class="w-max ml-4 lg:ml-0"
        border-color="border-transparent"
        bg-color="bg-gray-300"
        bg-color-square="bg-gray-100"
        icon-color="text-gray-600"
        text-color="text-gray-900"
        icon="file-text"
        libelle="Historique des mouvements"
        :responsive="true"
        :enable-action="false"
      />
    </router-link>
  </div>
</template>

<script>
import ActionButton from './../ActionButton.vue';
import ClickOutside from 'vue-click-outside';
import axios from 'axios';
import Constants from './../../constants';
import CheckboxIndigo from './../../components/Inputs/CheckboxIndigo';
import JsFileDownload from 'js-file-download';
import { mapGetters } from 'vuex';

export default {
  components: {
    ActionButton,
    CheckboxIndigo,
  },

  props: {
    canSwap: Boolean,
    uniqueJobs: Array,
    jobs: Array,
    infosPass: Object,
    listModulesPagesToExport: Array,
    moduleName: String,
    listModulesPages: Array,
  },

  data() {
    return {
      exportPDF: {
        listPage: [''],
      },
      dropDownExportMenu: false,
      dropDownPrintMenu: false,
      listModulesToExport: [],
      typeExportInProgress: '',
      typeExport: 'neopass',
      errorExportPdf: '',

      constants: Constants,
    };
  },

  methods: {
    displaySwap() {
      this.$emit('displaySwap');
    },

    displayFriseChronologique() {
      this.$emit('displayFriseChronologique');
    },

    displayDropDownExport() {
      this.dropDownExportMenu = !this.dropDownExportMenu;

      if (this.dropDownPrintMenu) {
        this.dropDownPrintMenu = false;
      }
    },

    displayDropDownPrint() {
      this.dropDownPrintMenu = !this.dropDownPrintMenu;

      if (this.dropDownExportMenu) {
        this.dropDownExportMenu = false;
      }
    },

    addModuleToExport(id) {
      if (this.listModulesToExport.includes(id)) {
        let idToDelete = Object.keys(this.listModulesToExport).find(
          (key) => this.listModulesToExport[key] === id
        )[0];
        this.listModulesToExport.splice(idToDelete, 1);
      } else if (!this.listModulesToExport.includes(id)) {
        this.listModulesToExport.push(id);
      }
    },

    forceHide(e) {
      this.listModulesToExport = [];
      this.typeExport = 'neopass';
      this.errorExportPdf = '';

      if (e.target.classList.contains('dropDownExportMenu')) {
        this.displayDropDownExport();
      } else {
        if (this.dropDownExportMenu) {
          this.dropDownExportMenu = false;
        }
      }

      if (e.target.classList.contains('dropDownPrintMenu')) {
        this.displayDropDownPrint();
      } else {
        if (this.dropDownPrintMenu) {
          this.dropDownPrintMenu = false;
        }
      }
    },

    selectAllModuleToExport() {
      if (
        this.listModulesPagesToExport.length ==
                this.listModulesToExport.length
      ) {
        this.listModulesToExport = [];
      } else {
        this.listModulesToExport = this.listModulesPagesToExport.map(
          (m) => m['id']
        );
      }
    },

    async exporterNeopass(isDownload) {
      let idPass = this.infosPass.id_pass;

      this.typeExportInProgress = 'neopass';
      this.errorExportPdf = '';

      await axios({
        url: `/api/pdf/neopass/${idPass}`,
        method: 'POST',
        responseType: 'blob', // Important
        data: {
          listModules: this.listModulesToExport,
        },
      })
        .then((response) => {
          let filename = `${this.infosPass.firstname} ${this.infosPass.lastname}.pdf`;

          if (this.listModulesToExport.length > 1) {
            filename = `Neopass - ${filename}`;
          }
          if (this.listModulesToExport.length === 1) {
            let displayName = this.listModulesPages.filter((module) => module.id === this.listModulesToExport[0])[0].display_name;
            filename = `${displayName ?? 'Neopass'} - ${filename}`;
          }

          if (isDownload) {
            JsFileDownload(response.data, filename);
          } else {
            window.open(URL.createObjectURL(response.data));
          }

          this.typeExportInProgress = '';
        })
        .catch((error) => {
          this.typeExportInProgress = '';
          this.errorExportPdf =
                        'Une erreur est survenue lors de l\'export des données en PDF. Veuillez contacter le service technique pour régler ce problème.';
          console.log('ERRRR:: ', error);
        });
    },

    async exporterCV(isDownload) {
      let idPass = this.infosPass.id_pass;

      this.typeExportInProgress = 'cv';
      this.errorExportPdf = '';

      await axios({
        url: '/api/pdf/cv/' + idPass,
        method: 'GET',
        responseType: 'blob', // Important
      })
        .then((response) => {
          let filename = `CV ${this.infosPass.firstname} ${this.infosPass.lastname}.pdf`;

          if (isDownload) {
            JsFileDownload(response.data, filename);
          } else {
            window.open(URL.createObjectURL(response.data));
          }

          this.typeExportInProgress = '';
        })
        .catch((error) => {
          this.typeExportInProgress = '';
          this.errorExportPdf =
                        'Une erreur est survenue lors de l\'export des données en PDF. Veuillez contacter le service technique pour régler ce problème.';
          console.log('ERRRR:: ', error);
        });
    },

    async exporterFiche(isDownload, fiche) {
      let idPass = this.infosPass.id_pass;

      this.typeExportInProgress = 'fiche' + fiche.page_template.name;
      this.errorExportPdf = '';

      await axios({
        url: '/api/pdf/desc/' + fiche.template_id,
        method: 'GET',
        responseType: 'blob', // Important
      })
        .then((response) => {
          let filename =
            `${fiche.page_template.name ?? 'Fiche de poste'} - ${new Date().toLocaleDateString()}.pdf`;

          if (isDownload) {
            JsFileDownload(response.data, filename);
          } else {
            window.open(URL.createObjectURL(response.data));
          }

          this.typeExportInProgress = '';
        })
        .catch((error) => {
          this.typeExportInProgress = '';
          this.errorExportPdf =
                        'Une erreur est survenue lors de l\'export des données en PDF. Veuillez contacter le service technique pour régler ce problème.';
          console.log('ERRRR:: ', error);
        });
    },

    async exporterRefFormation(isDownload, refFormation) {
      let idPass = this.infosPass.id_pass;

      this.typeExportInProgress =
                'refFormation' + refFormation.page_template.name;
      this.errorExportPdf = '';

      await axios({
        url: '/api/pdf/refFormation/' + refFormation.template_id,
        method: 'GET',
        responseType: 'blob', // Important
      })
        .then((response) => {
          let filename =
            `${refFormation.page_template.name ?? 'Référentiel de formation'} - ${new Date().toLocaleDateString()}.pdf`;

          if (isDownload) {
            JsFileDownload(response.data, filename);
          } else {
            window.open(URL.createObjectURL(response.data));
          }

          this.typeExportInProgress = '';
        })
        .catch((error) => {
          this.typeExportInProgress = '';
          this.errorExportPdf =
                        'Une erreur est survenue lors de l\'export des données en PDF. Veuillez contacter le service technique pour régler ce problème.';
          console.log('ERRRR:: ', error);
        });
    },

    async exporterHistory(isDownload, evaluation) {
      let idPass = this.infosPass.id_pass;

      this.typeExportInProgress = 'history';
      this.errorExportPdf = '';

      await axios({
        url: '/api/pdf/history/' + idPass + '/' + evaluation.id,
        method: 'GET',
        responseType: 'blob', // Important
      })
        .then((response) => {
          let filename =
                        `Evaluation ${evaluation.data.name_temp} du ${evaluation.data.date_debut_evaluation} au ${evaluation.data.date_fin_evaluation}.pdf`;

          if (isDownload) {
            JsFileDownload(response.data, filename);
          } else {
            window.open(URL.createObjectURL(response.data));
          }

          this.typeExportInProgress = '';
        })
        .catch((error) => {
          this.typeExportInProgress = '';
          this.errorExportPdf =
                        'Une erreur est survenue lors de l\'export des données en PDF. Veuillez contacter le service technique pour régler ce problème.';
          console.log('ERRRR:: ', error);
        });
    },
  },

  computed: {
    ...mapGetters({
      structure: 'auth/structure',
    }),
  },

  directives: {
    ClickOutside,
  },
};
</script>
